import { render, staticRenderFns } from "./PlotList.vue?vue&type=template&id=9258d8c4&scoped=true"
import script from "./PlotList.vue?vue&type=script&lang=js"
export * from "./PlotList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9258d8c4",
  null
  
)

export default component.exports